import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentStore } from '../../../../../core/stores/payment.store';
import { PaymentService } from '../../../../../core/services/payment.service';
import { NO_SELECTED_CARD } from '../../../../../core/constants';

@Component({
  selector: 'app-saved-card',
  templateUrl: './saved-card.component.html',
  styleUrls: ['./saved-card.component.scss'],
})
export class SavedCardComponent implements OnInit {
  @Input() public isSavedPayment: boolean;
  @Input() public touched: boolean;
  @Input() public cardId: string;
  @Input() public isRemoveCard: boolean;
  @Input() public isSharedCardsEnabled: boolean;
  @Output() public getCardId: EventEmitter<string> = new EventEmitter<string>();
  @Output() public getIsRemoveCard: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public getSavedPayment: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public getTouched: EventEmitter<boolean> = new EventEmitter<boolean>();
  public isRemovalProcess: boolean;

  constructor(
    public paymentStore: PaymentStore,
    public paymentService: PaymentService
  ) { }

  ngOnInit() {}

  public get customerCards(): any[] {
    const cards = [];
    for (const card of this.paymentStore.customer.cards) {
      if (!cards.find( (customerCard) =>
        card.last4 === customerCard.last4 &&
        card.exp_month === customerCard.exp_month &&
        card.exp_year === customerCard.exp_year)) {
        cards.push(card);
      }
    }
    return cards;
  }

  public isChosenCard(card: any): boolean {
    return this.cardId === card.id;
  }

  public choosePaymentCard(card: any): void {
    this.cardId = card.id;
    this.getCardId.emit(card.id);
  }

  public switchFormForRemoveCard(): void {
    this.isRemoveCard = !this.isRemoveCard;
  }
  public useSavedPayment(checked: boolean): void {
    const savedPaymentState = this.paymentService.getSavedPaymentState(checked);
    this.isSavedPayment = savedPaymentState.isSavedPayment;
    this.touched = savedPaymentState.touched;
    this.cardId = savedPaymentState.cardId;
    this.getTouched.emit(this.touched);
    this.getSavedPayment.emit(this.isSavedPayment);
    this.getCardId.emit(this.cardId);
  }
  public removeCard(cardIndex): void {
    const cardId = this.paymentStore.customer.cards[cardIndex].id;
    this.isRemovalProcess = true;
    this.paymentService.removeCustomerCard(
      this.paymentStore.customer.squareCustomerId,
      cardId,
      this.paymentStore.customer.sharedCards,
      this.isSharedCardsEnabled
    ).subscribe(() => {
      this.paymentStore.customer.cards.splice(cardIndex, 1);
      this.isRemovalProcess = false;
      if (this.paymentStore.customer.cards.length === 0) {
        this.isRemoveCard = false;
        this.getIsRemoveCard.emit(true);
        this.paymentStore.customer.cards = null;
        this.cardId = NO_SELECTED_CARD;
        this.getCardId.emit(this.cardId);
      }
    });
  }
}
